import React from 'react';

import { useGetStreamsHeatmapQuery } from '../../redux/apis/analyticsManagement/aMIptvAnalyticsApiSlice';
import HeatMap from '../other/charts/HeatMap';
import ComponentLoader from '../other/ComponentLoader';
import { Card, CardBody, CardExpandToggler } from '../other/card/card';

const HEATMAP_HEIGHT = 500;

const IPTVStreamsPerCountry = () => {
  const { data, isLoading, isError, error } = useGetStreamsHeatmapQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });

  const items = Array.isArray(data) ? data : [];
  const hasNumeric = items.filter(item => item.code && typeof item.value === 'number').length > 0;

  return (
    <div className='row g-2 mt-1'>
      <div className='col-12'>
        <Card className='mb-0'>
          <CardBody className='relative p-0'>
            {isError ? (
              <div className='absolute inset-0 d-flex items-center justify-center p-3 text-danger small bg-white bg-opacity-75'>
                Failed to load.
                {error?.data?.message ? ` ${error.data.message}` : ''}
              </div>
            ) : null}

            <div className='p-4 d-flex flex-wrap justify-content-between gap-2'>
              <div className='d-flex flex-column'>
                <div className='d-flex fw-bold small'>Overall Streams Per Country for Current Year</div>
              </div>
              <div className='align-self-start'>
                <CardExpandToggler />
              </div>
            </div>

            <div className='p-4 pt-0'>
              <div className='small text-body-secondary'>
                <div className='mt-2 position-relative' style={{ minHeight: HEATMAP_HEIGHT }}>
                  {isLoading ? <ComponentLoader /> : null}
                  {hasNumeric ? (
                    <HeatMap items={items} height={HEATMAP_HEIGHT} mapId='iptv-streams-heatmap' />
                  ) : !isLoading ? (
                    <div className='d-flex text-base h-100 align-items-center justify-content-center text-center px-2'>
                      No stream heatmap data available.
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default IPTVStreamsPerCountry;
